import { createApp } from 'vue'

import vSelect from 'vue-select'
import SvgIcon from './svg-icon.vue'
import VueTagsInput from '@sipec/vue3-tags-input'
import Popper from "vue3-popper"

function makeApp(rootComponent, props) {
  const app = createApp(rootComponent, props)
  app.component('v-select', vSelect)
  app.component('svg-icon', SvgIcon)
  app.component('vue-tags-input', VueTagsInput)
  app.component('Popper', Popper)
  return app
}

import ArtistAutocomplete from './artist_autocomplete.vue'
import Upload from './upload.vue'
import MixEditForm from './mix_edit_form.vue'
import App from './app.vue'
import router from './router.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import $ from 'cash-dom'

const components = [
  [Upload, "#upload-form"],
  [ArtistAutocomplete, ".artist-autocomplete"],
  [MixEditForm, ".mix-edit-form"],
]

$(document).ready(() => {
  // Mount the SPA app (only present on spa-layout pages)
  const spaEl = document.getElementById('vue-app')
  if (spaEl) {
    const app = makeApp(App)
    app.use(router)
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.mount(spaEl)
    return
  }

  // Per-component mounts for non-SPA pages
  for ( const arr of components ) {
    const component = arr[0]
    const selector = arr[1]
    $(selector).each( (_, div) => {
      const props = $(div).data()
      const app = makeApp(component, props)
      app.mount(div)
    })
  }
})
